import moment from "moment"
import { useDashboardStore } from "../../stores/dashboardStore"

/** Mesmo cálculo de início de semana (domingo) usado em Dashboard e DateRange. */
export const dashboardPeriodoPadraoObter = () => {
  const hoje = new Date()
  const diaDaSemana = hoje.getDay()
  const inicioDaSemana = new Date(hoje)
  inicioDaSemana.setDate(hoje.getDate() - diaDaSemana)

  return {
    date_from: `${inicioDaSemana.getFullYear()}-${String(inicioDaSemana.getMonth() + 1).padStart(2, "0")}-${String(
      inicioDaSemana.getDate(),
    ).padStart(2, "0")}`,
    date_to: moment().format("YYYY-MM-DD"),
    days: 0,
  }
}

export const prefetchPacoteDashboard = () => {
  import(/* webpackPrefetch: true */ "../../pages/Dashboard")
}

export const prefetchDashboardPeriodo = () => {
  const nCompanyId = localStorage.getItem("companyId")
  if (!nCompanyId) return

  prefetchPacoteDashboard()

  const oPeriodo = dashboardPeriodoPadraoObter()
  const { periodoCompletoBuscar } = useDashboardStore.getState()

  periodoCompletoBuscar({
    ...oPeriodo,
    companyId: Number(nCompanyId),
  }).catch(() => {})
}

export const prefetchDashboardCompleto = () => {
  prefetchDashboardPeriodo()
}
